var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 1.16602H8.66927",
    stroke: "#0D4740",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.16602L7.5 2.91602",
    stroke: "#0D4740",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8125 8.16504C1.8125 5.02392 4.35888 2.47754 7.5 2.47754C10.6411 2.47754 13.1875 5.02392 13.1875 8.16504C13.1875 11.3062 10.6411 13.8525 7.5 13.8525C4.35888 13.8525 1.8125 11.3062 1.8125 8.16504ZM9.55936 6.72472C9.73021 6.55387 9.73021 6.27686 9.55936 6.10601C9.38851 5.93515 9.1115 5.93515 8.94064 6.10601L7.19064 7.85601C7.01979 8.02686 7.01979 8.30387 7.19064 8.47472C7.3615 8.64558 7.63851 8.64558 7.80936 8.47472L9.55936 6.72472Z",
    fill: "#0D4740"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2891 4.08268L11.5807 3.79102",
    stroke: "#0D4740",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerFilled);
export default __webpack_public_path__ + "static/media/timer-filled.f85be4ed0c928be9b4bc1893651bd97b.svg";
export { ForwardRef as ReactComponent };